export const InputType = {
  PERCENT: 'PERCENT',
  DOLLARS: 'DOLLARS',
  DEGREES: 'DEGREES',
  NONE: 'NONE',
};
